import {Pipe,PipeTransform} from '@angular/core';


@Pipe({
    name: "empty",
    pure:true
})
export class EmptyPipe implements PipeTransform{

    transform(value: any,...args: any[]) {
        if(value == null || value == undefined) return 'N/A';
        return value;
    }

}